import React, { Component } from 'react'
import { connect } from 'react-redux'
import VaultResPurchaseSample from '../samples/VaultResPurchaseSample'
import { makeVaultResPurchaseCC } from '../../../actions/vaultFinancialAction'
import { updateOrderId } from '../../../actions/commonActions'
import { _VAULTFINANCIAL } from '../../../actions/types'
const OBJECT = [  "resPurchaseCC", "resPurchaseCC", "resPurchaseCC"]
const COF = [  "cof", "cof", "cof"]
const METHODS = { 
    SetEncTrack2:[  ".SetEncTrack2(enc_track2);", ".SetEncTrack2(enc_track2);", "'enc_track2'=>$enc_track2"],
    SetDeviceType:[  ".SetDeviceType;", ".SetDeviceType;", "'device_type'=>$device_type"],
    SetCusId: [  ".SetCustId(cust_id);", ".setCustId(cust_id);", "'cust_id'=>$cust_id"],
    SetAvsCheck: [  ".SetAvsInfo(avsCheck);", ".setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    SetEmail: [  ".SetEmail(email);", ".setEmail(email);", "'email'=>$email"],
    SetPhone: [  ".SetPhone(phone);", ".setPhone(phone);", "'phone'=>$phone"],
    SetAmount:  [  ".SetAmount(amount);", ".setAmount(amount);", "'amount'=>$amount"],
    SetNote: [  ".SetNote(note);", ".setNote(note);", "'note'=>$note"],
    SetDataKeyFormat: [  ".SetDataKeyFormat(data_key_format);", ".SetDataKeyFormat(data_key_format);", "'data_key_format'=>$data_key_format"],
    SetDataKey: [  ".setData(data_key);", ".setData(data_key);", "'data_key'=>$data_key"],
    CreditCardNumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    ExpiryDay: [  ".setExpdate(expiry_date);", ".setExpDate(expiry_date);", "'expdate'=>$expiry_date"],
    SetStatusCheck: [  ".SetStatusCheck(expiry_date);", ".setStatusCheck(expiry_date);", "$mpgHttpPost =newmpgHttpsPostStatus($store_id,$api_token,$status,$mpgRequest);"],
    SetDuration: [  ".SetDuration(duration);", ".SetDuration(duration);", "'duration'=>$duration"],
    CreditCardCumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    SetCryptType: [  ".SetCryptType(crypt);", ".setCryptType(crypt);", "'crypt_type'=>$crypt"],    
    setCotInfo: [  ".SetCofInfo(cof);", ".setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    SetCusInfo: [  ".SetCustInfo(customer);", ".setCustInfo(customer);", "$mpgTxn->setCustInfo($mpgCustInfo);"],
    SetIssueId: [  `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{$cof->setIssuerId("VALUE_FOR_ISSUER_ID");}`],
    SetOrderId: [  ".SetOrderId(order_id);", ".SetOrderId(order_id);", "'order_id'=>$order_id"],
    SetTxnNumber: [  ".SetTxnNumber(txn_number);", "setTxnNumber(txn_number);", "'txn_number'=>$txn_number"],
    SetRecur:[  ".SetRecur(recurring_cycle);", ".setRecurInfo(recurInfo);", "$mpgTxn->setRecur($mpgRecur);"],
    SetDynamicDescriptor:[  ".SetDynamicDescriptor(dynamic_descriptor);", ".setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
    setCvdInfo:[  ".SetCvdInfo(cvdCheck);", ".setCvdInfo(cvdCheck);", "$mpgTxn->setCvdInfo($mpgCvdInfo);"],
    SetPaymentIndicator:[  `SetPaymentIndicator("PAYMENT_INDICATOR_VALUE");`,  `.setPaymentIndicator("PAYMENT_INDICATOR_VALUE");`, `$cof->setPaymentIndicator("PAYMENT_INDICATOR_VALUE");`],
    SetPaymentInfo:[  `SetPaymentInformation("PAYMENT_INFO_VALUE");`,  `.setPaymentInformation("PAYMENT_INFO_VALUE");`, `$cof->setPaymentInformation("PAYMENT_INFO_VALUE");`],
}
export class VaultPurchase extends Component {
    state = {
        showError:false,
        showSuccess:false,
        justClicked:false,
      };
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }


    //TODO fix this
    componentDidUpdate() {
        const { respurchaseSuccess,ResPurchaseResponse,loading } = this.props; 
        if(ResPurchaseResponse!=="No request has been made."  && this.state.justClicked){
            if(respurchaseSuccess){
                    this.setState({ showError: false,showSuccess: true,justClicked:false });  
                }
            else {
                if(!loading){
                    this.setState({  showError: true, showSuccess: false,justClicked:false });
                }
            }
        }
    }
    //TODO fix this
    async onMakePurchasePress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _VAULTFINANCIAL, orderId: newOrderId });
        const { storeId, apiToken, order_id, pan, expdate, amount } = this.props;
        const purchaseRequest = { storeId, apiToken, order_id, pan, expdate, amount };
        this.props.makeVaultResPurchaseCC(purchaseRequest);
        this.setState({justClicked:true});
    }

    renderMessage() {
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#ffcccc', color:'#cc0000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}>
                    <strong>Error!</strong><br />
                    Please check your parameters within Vault ResPurchaseCC.
                </div>
            );
        }
        // else if(this.state.showSuccess) {
        //     return (
        //         <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}>
        //             <strong>Vault ResPurchaseCC Accepted!</strong><br />
        //             The returned receipt has been inserted to the JSON on the right, you can make another Vault Request now.
        //         </div>
        //     );
        // }
    }
    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample ResPurchaseCC</h3>
                <VaultResPurchaseSample/>
                <div className="requestButton" onClick={() => this.onMakePurchasePress()}>
                    ResPurchaseCC Request
                </div> 
                {this.renderMessage()}
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
    renderDocument() {      
        const { progLangId } = this.props;  
        return (
            <div className="stepPageContainer">
            <div>
            <h3 className="stepPageTitle">Purchase with Vault – ResPurchaseCC</h3>
            <p><b>Purchase with Vault transaction object definition</b></p>   

            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>ResPurchaseCC resPurchaseCC = new ResPurchaseCC();
                            </code>
                        case 1:
                            return <code>ResPurchaseCC resPurchaseCC = new ResPurchaseCC();

                            </code>
                        case 2:
                            return <code>
                                {`$txnArray = array(‘type’=>’res_purchase_cc', …);`}<br/>
                                {`$mpgTxn = new mpgTransaction($txnArray);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
             <p><b>HttpsPostRequest object for Purchase with Vault transaction</b></p>    
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();
                            </code>
                        case 1:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();

                            </code>
                        case 2:
                            return <code>
                                {`$mpgRequest = new mpgRequest($mpgTxn);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
                   {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>mpgReq.setTransaction(resPurchaseCC);</code>
                        case 1:
                            return <code>mpgReq.setTransaction(resPurchaseCC);</code>
                        case 2:
                            return <code>
                                {`$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);`}
                                </code>
                        default:
                            return null
                        }
                    })()}


        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Purchase with Vault transaction request fields – Required</h3>
        <p>For a full description of mandatory and optional values, see Appendix A Definition of Request Fields.</p>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>data key</td>
                    <td>String<br/>25-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetDataKey[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>order ID<br /></td>
                    <td>String<br/>50-character alphanumeric<br/>{`a-Z A-Z 0-9 _ - : . @ spaces`}</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetOrderId[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>amount</td>
                    <td>String<br/>
                        10-character decimal<br/>
                        Up to 7 digits (dollars) +
                        decimal point (.) + 2 digits
                        (cents) after the decimal
                        point<br/>
                            <p className="note">
                                <strong>EXAMPLE:: </strong> 
                                1234567.89      
                            </p>
                    </td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetAmount[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>electronic commerce indicator</td>
                    <td>String<br/>1-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCryptType[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>
                        Credential on File Info<br/>
                        cof<br/>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                This is a nested object
                                within the transaction, and
                                required when storing or
                                using the customer's stored
                                credentials. For information
                                about fields in the Credential
                                on FIle Info object, see Credential
                                on File Info Object
                                and Variables. 
                            </p>
                    </td>

                    <td>Object<br/>N/A</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.setCotInfo[progLangId]}</code></td>
                </tr>
                </tbody>
            </table>





        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Purchase with Vault transaction request fields – Optional</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>status check</td>
                    <td>Boolean<br/>true/false</td>
                    <td><code style={{fontSize:"0.9vw"}}>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetStatusCheck[progLangId]}</code></td>
                </tr>

                <tr>
                    <td>expiry date<br /></td>
                    <td>String<br/>
                        4-character numeric<br/>
                        YYMM format.<br/> 
                        (Note that this is reversed from the date displayed on the card, which is MMYY)
                    </td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.ExpiryDay[progLangId]}</code></td>

                </tr>
                <tr>
                    <td>customer ID</td>
                    <td>String<br/>
                        50-character alphanumeric<br/>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                Some special characters are not
                                allowed:
                                {`< > $ % = ? ^ { } [ ] \\`}
                            </p>
                    </td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCusId[progLangId]}</code></td>
                </tr>

                <tr>
                    <td>dynamic descriptor</td>
                    <td>String<br/>
                        20-character alphanumeric<br/> 
                        total of 22 characters including<br/> 
                        your merchant name
                        and separator<br/>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                Some special characters are not
                                allowed:
                                {`< > $ % = ? ^ { } [ ] \\`}
                            </p>
                    </td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetDynamicDescriptor[progLangId]}</code></td>
                </tr>
                
                <tr>
                    <td>Customer Information<br /></td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCusInfo[progLangId]}</code></td>
                </tr>

                <tr>
                    <td>AVS Information</td>
                    <td>Object<br/>N/A</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetAvsCheck[progLangId]}</code></td>
                </tr>

                <tr>
                    <td>CVD Information<br />
                            <p className="note">
                                <strong>NOTE: </strong> 
                                When storing credentials
                                on the initial transaction,
                                the CVD object must
                                be sent; for subsequent transactions
                                using stored credentials,
                                CVD can be sent
                                with cardholder-initiated
                                transactions <b>only—merchants
                                must not store CVD
                                information</b>.
                            </p>
                        </td>
                    <td>Object<br/>N/A</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.setCvdInfo[progLangId]}</code></td>
                </tr>

                <tr>
                    <td>Recurring Billing</td>
                    <td>Object<br/>N/A</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetRecur[progLangId]}</code></td>
                </tr>

                </tbody>
            </table>





            
        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Credential on File Info object request fields</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>issuer ID<br />
                            <p className="note">
                                <strong>NOTE: </strong> 
                                This variable is
                                required for all merchant-initiated
                                transactions following
                                the first one; upon sending
                                the first transaction, the
                                issuer ID value is received in
                                the transaction response and
                                then used in subsequent
                                transaction requests.
                            </p>
                    </td>
                    <td>String<br/>15-character alphanumeric variable length</td>
                  <td><code>{progLangId !== 2 ? COF[progLangId] : ''}{METHODS.SetIssueId[progLangId]}</code>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                For a list and explanation of the
                                possible values to send for this variable,
                                see Definition of Request Fields – Credential
                                on File
                            </p>
    
                    </td>
                </tr>

                <tr>
                    <td>payment indicator<br />
                            <p className="note">
                                <strong>NOTE: </strong> 
                                In Credential on File
                                transactions where the
                                request field e-commerce
                                indicator is also being sent,
                                the acceptable values for ecommerce
                                indicator are
                                dependent on the value sent
                                for payment indicator; see
                                request field definitions for
                                more information.
                            </p>
                    </td>
                    <td>String<br/>1-character alphabetic</td>
  
                    <td><code>{progLangId !== 2 ? COF[progLangId] : ''}{METHODS.SetPaymentIndicator[progLangId]}</code>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                For a list and explanation of the
                                possible values to send for this variable,
                                see Definition of Request Fields – Credential
                                on File
                            </p>
    
                    </td>
                </tr>


                
                <tr>
                    <td>payment information
                    </td>
                    <td>String<br/>1-character alphabetic</td>

                    <td><code>{progLangId !== 2 ? COF[progLangId] : ''}{METHODS.SetPaymentInfo[progLangId]}</code>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                For a list and explanation of the
                                possible values to send for this variable,
                                see Definition of Request Fields – Credential
                                on File
                            </p>
    
                    </td>
                </tr>
               </tbody>
            </table>
            <p><b>Vault response fields</b></p>
            <p>For a list and explanation of (Receipt object) response fields that are available after sending this Vault
                transaction, see Definitions of Response Fields.
            </p>  
          </div>
        </div>
        )
    }
}



const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { respurchaseSuccess,ResPurchaseResponse,loading } = state.vaultFinancial.main;
    const { storeId, apiToken, order_id, pan, expdate, amount} = state.vaultFinancial.main.config;
    return { mode, storeId, apiToken, order_id, pan, expdate, amount,loading, progLangId: state.common.progLangList.selection,respurchaseSuccess,ResPurchaseResponse };
  }

export default connect(mapStateToProps,{updateOrderId,makeVaultResPurchaseCC})(VaultPurchase) 